export enum OS_LABEL {
  IOS = 'iOS',
  ANDROID = 'Android',
  OTHER = 'Otro',
  WINDOWS_PHONE = 'Windows Phone',
  WEB = 'Web',
  IOS_WEB = 'iOS Web',
  ANDROID_WEB = 'Android Web',
  WINDOWS_PHONE_WEB = 'Windows Phone Web',
}

export enum OS {
  IOS = 0,
  ANDROID,
  OTHER,
  WINDOWS_PHONE,
  WEB,
  IOS_WEB,
  ANDROID_WEB,
  WINDOWS_PHONE_WEB,
}

export enum GROUP_BY_OS {
  ALL = 'all',
  ANDROID = 'android',
  IOS = 'ios',
}
